import React from "react";

const SummaryCard = ({label, value, minWidth = 220}) => (
    <div
        className="card rounded-lg p-3 flex-fill"
        style={{minWidth, border: "1px solid #c1c7d0"}}
    >
        <div style={{fontSize: "0.875rem", color: "#5e6c84"}}>{label}</div>
        <div style={{fontSize: "1.75rem", fontWeight: 600, marginTop: 4}}>{value}</div>
    </div>
);

export default SummaryCard;
